import React from "react";
import { Control } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import Team from "@/components/molecules/RegisterCompanySteps/Team";

interface TeamPanelProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const TeamPanel: React.FC<TeamPanelProps> = ({ control, saveDraft }) => {
  return (
    <React.Fragment>
      <Team control={control} saveDraft={saveDraft} />
    </React.Fragment>
  );
};

export default TeamPanel;
